import { useBlockProps } from '@wordpress/block-editor';

export default function save({ attributes }) {
    const blockProps = useBlockProps.save();

    return (
        <div
		{ ...useBlockProps.save() }
        style={ {
            width: isNaN(attributes.custom_size_width) || attributes.custom_size_width === '__IMAGE__' 
            ? '150px' 
            : attributes.custom_size_width + 'px',
            height: isNaN(attributes.custom_size_height) || attributes.custom_size_height === '__IMAGE__' 
            ? '150px' 
            : attributes.custom_size_height + 'px',
            marginInline: 'auto',
        } }
        >
            __GRAPH__
        </div>
    );
}